import React from 'react';
import ALink from 'tradera/components/alink/alink';
import ArrowRightIcon from '@tradera/blueprint/theme/icons2/arrow-right.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './start-page-section-title.module.scss';
import useIsMobile from 'tradera/hooks/use-is-mobile';

type StartPageSectionTitleProps =
    | {
          className?: string;
          href?: never;
          inSpa?: never;
          onClick?: never;
          noMargins?: boolean;
          showAll?: never;
          children: ReactNode;
      }
    | {
          className?: string;
          href: string;
          inSpa: boolean;
          onClick?: () => void;
          noMargins?: boolean;
          showAll?: boolean;
          children: ReactNode;
      };

export const StartPageSectionTitle = ({
    className,
    href,
    inSpa,
    onClick,
    noMargins = false,
    showAll = false,
    children
}: StartPageSectionTitleProps) => {
    const { t } = useTranslator();
    const isMobile = useIsMobile();
    return (
        <h3
            className={classNames(
                'text-styled',
                !noMargins && 'mx-2 mx-md-3 mx-lg-2 mx-xl-0 mb-2 mb-md-3',
                className
            )}>
            {href ? (
                <ALink
                    className={styles.link}
                    href={href}
                    onClick={onClick}
                    useLink={inSpa}>
                    {children}
                    <span className={styles.hiddenText}>
                        {showAll
                            ? t('startPage_showAll_link')
                            : t('startPage_showMore_link')}
                    </span>
                    <ArrowRightIcon
                        className={classNames(
                            'icon',
                            isMobile ? 'icon-sm' : 'icon-md',
                            'ml-1'
                        )}
                    />
                </ALink>
            ) : (
                children
            )}
        </h3>
    );
};
